import { render, staticRenderFns } from "./lookQuotation.vue?vue&type=template&id=53013555&scoped=true&"
import script from "./lookQuotation.vue?vue&type=script&lang=js&"
export * from "./lookQuotation.vue?vue&type=script&lang=js&"
import style0 from "./lookQuotation.vue?vue&type=style&index=0&id=53013555&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53013555",
  null
  
)

export default component.exports